import { render, staticRenderFns } from "./EditCompanyInformation.vue?vue&type=template&id=2ccbc6aa&scoped=true&style=font-family%3A%20'roboto'%3B&"
import script from "./EditCompanyInformation.vue?vue&type=script&lang=js&"
export * from "./EditCompanyInformation.vue?vue&type=script&lang=js&"
import style0 from "./EditCompanyInformation.vue?vue&type=style&index=0&id=2ccbc6aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccbc6aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VIcon,VImg,VLayout,VRow,VSelect,VTextField})
